import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, ViewController } from 'ionic-angular';
import { Globals } from '../../../globals';
import { OrdersServices } from '../../kitchen/services';
import { OrdersCoServices } from '../../orders/services';
import { TranslateService } from '@ngx-translate/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { HttpClient } from '@angular/common/http';
import * as firebase from 'firebase';
import { CustomersCreateDataPage } from '../../customers/customers-create/customers-create-data/customers-create-data';
import { ConfigurationTicketsListPage } from '../../configuration/configuration-tickets/configuration-tickets-list/configuration-tickets-list';


/**
 * Generated class for the StockListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-modal-ratings',
  templateUrl: 'modal-ratings.html',
})
export class ModalRatings {

  rating: any;
  ratings: any;
  public ticket: any;
  public customer: any;
  public get_info_complete: boolean = false;
  public firestore: any;
  reply: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public globals: Globals,
    public ordersServices: OrdersServices,
    public ordersCoServices: OrdersCoServices,
    public http: HttpClient,
    public translate: TranslateService,
    public afs: AngularFirestore,
    public toastCtrl: ToastController,) {
    this.firestore = firebase.firestore();
    this.rating = this.navParams.get('rating');
    this.ratings = this.navParams.get('ratings');
    this.getInfo();
  }

  close() {
    this.viewCtrl.dismiss();
  }

  async getInfo() {
    await this.getTicket();
    await this.getCustomer();
    this.reply = this.rating.reply;
    this.get_info_complete = true;
  }

  openCustomer(customer) {
    this.navCtrl.push(CustomersCreateDataPage, {
      update_state: true,
      customer_uid: customer.UID,
      name: customer.name,
      business_name: customer.business_name,
      business_number: customer.business_number,
      email: customer.email,
      phone: customer.phone,
      address: customer.address,
      note: customer.note,
      alegra_contact_id: customer.alegra_contact_id,
    })
  }

  openTicket(ticket) {
    this.navCtrl.push(ConfigurationTicketsListPage, {
      state: 'closed',
      ticket: ticket,
    });
  }

  save() {
    if (this.reply == '') {
      let toast = this.toastCtrl.create({
        message: this.translate.instant('rating-tienes-escribir-respuesta'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    } else {
      //Busamos el rating en la lista de todos los ratings para actualizar los datos dentro de la aplicacion
      var index_rating = this.ratings.findIndex(x => x.UID == this.rating.UID);
      this.rating.reply = this.reply;
      this.rating.state = 'answered';
      this.ratings[index_rating] = this.rating;

      //Actualizamos la respuesta del Restaurante
      this.firestore.collection('restaurants/' + this.globals.restaurant_uid + '/ratings').doc(this.rating.UID).update({
        'reply': this.reply,
        'state': 'answered',
      }).then(async doc => {

        if (this.customer.length != 0) {
          //send email answer rating
          this.afs.collection('_emails').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'type': 'erating_response',
            'reply': this.reply,
            'comment': this.rating.comment,
            'customer_email': this.customer.email,
            'customer_name': this.customer.name,
            'restaurant_logo': this.getImageUrl(this.globals.restaurant.logo), //this.restaurant.logo
            'restaurant_company': this.globals.restaurant.company,
          }).then(async ref => { });
          let toast = this.toastCtrl.create({
            message: this.translate.instant('rating-respuesta-enviada'),
            duration: 3000,
            position: 'bottom'
          });
          toast.present();
        } else {
          //Conseguimos el email del usuario separando el string y limpinado el ultimo caracter )
          var _customer = this.rating.customer.split('(');
          var _name = _customer[0];
          var _email = _customer[1].slice(0, -1);
          //send email answer rating
          this.afs.collection('_emails').add({
            'UID_RESTAURANT': this.globals.restaurant_uid,
            'type': 'erating_response',
            'reply': this.reply,
            'comment': this.rating.comment,
            'customer_email': _email,
            'customer_name': _name,
            'restaurant_logo': this.getImageUrl(this.globals.restaurant.logo), //this.restaurant.logo
            'restaurant_company': this.globals.restaurant.company,
          }).then(async ref => { });
          let toast = this.toastCtrl.create({
            message: this.translate.instant('rating-respuesta-enviada'),
            duration: 3000,
            position: 'bottom'
          });
          toast.present();
        }
        this.viewCtrl.dismiss();
      });
    }
  }

  async getTicket() {
    await this.firestore.collection('tickets').doc(this.rating.uid_ticket).get().then(doc => {
      if (doc.exists) {
        this.ticket = doc.data();
        this.ticket.UID = doc.id;
      } else {
        this.ticket = [];
      }
    });
  }
  async getCustomer() {
    await this.firestore.collection('customers').doc(this.rating.uid_customer).get().then(doc => {
      if (doc.exists) {
        this.customer = doc.data();
        this.customer.UID = doc.id;
      } else {
        this.customer = [];
      }
    });
  }
  getImageUrl(img_url) {
    if (img_url != '' && img_url != undefined) {
      img_url = 'https://firebasestorage.googleapis.com/v0/b/mycheftool-d3899.appspot.com/o/' + img_url.replace('logo/', 'logo%2F') + '?alt=media';
      return img_url;
    } else {
      return '';
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/components/modal-ratings/modal-ratings.ts